import React, { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { useNavigate } from 'react-router-dom';
import { auth, db } from 'config/firebase';
import { collection, orderBy, query, where} from 'firebase/firestore';
import { Card, Row, Col, Image } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/merlin/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/merlin/advance-table/AdvanceTable';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import PageHeader from 'components/common/PageHeader';
import Lottie from 'lottie-react';
import dotsAnimation from 'assets/lottie/dots.json';


const ProductLists = () => {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();

  const [newProducts, productsLoading] = useCollectionData(
    query(
      collection(db, "productChangeHistory"),
      where("special", "array-contains-any", ["NEW PRODUCT SKU","PACK CHANGE", "NEW DISC", "RETURNED", "SLOT CHANGE"]),
      orderBy("timestamp", "desc")
    ), {
      snapshotListenOptions: { includeMetadataChanges: true },
    });

    
  const columns = [
    {
      accessor: 'timestamp',
      Header: 'Timestamp',
      Cell: rowData => {
        const { timestamp } = rowData.row.original;
        const dateString = timestamp.toDate().toDateString();
        return (
          <span>{dateString}</span>
        
        )
      }
    },
    {
      accessor: 'special',
      Header: 'Event',
      Cell: rowData => {
        const { special } = rowData.row.original;
        
        return (
          <ul>
            {special.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        
        )
      }
    },
    {
      accessor: 'sku',
      Header: 'SKU',
      Cell: rowData => {
        const { sku } = rowData.row.original;
        
        return (
          <span>
            <a href={`/products/${sku}`}>{sku}</a>
          </span>
        );
      }
    }
  ];

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate('/');

  }, [user, loading, navigate]);

  return (
    <>
      
      {!productsLoading ? 
        <Card className="">
      <AdvanceTableWrapper
            columns={columns}
            data={newProducts}
            sortable
            pagination
            setPageSize
            >
            <div className="m-3">
            <Row className="flex-end-center mb-3">
              <Col>
                  <AdvanceTableSearchBox table/>
              </Col>
            </Row>
              <AdvanceTableFooter
                rowCount={newProducts.length}
                table
                rowInfo
                navButtons
                rowsPerPageSelection
              />
            
            </div>
            <AdvanceTable
              table
              headerClassName="bg-200 text-900 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                bordered: false,
                striped: true,
                className: 'fs--1 mb-0 overflow-hidden'
              }}
            />
            <div className="m-3"><AdvanceTablePagination table /></div>
            
          </AdvanceTableWrapper>
          </Card>
          :
          <div>
                <Row className="align-items-center">

                <Col>
                    <Lottie animationData={dotsAnimation} style={{height: 300}} />
                </Col>

                </Row>
              </div>
      }
      
    </>
  )
};

export default ProductLists;
